<template>
    <router-link :to="route" tag="div"><slot></slot></router-link>
</template>
<script>
export default {
     props: ['to'],
     computed:{
         route(){
             return Object.assign({ query: this.$route.query }, this.to);
         }
     }
}
</script>


// WEBPACK FOOTER //
// front/src/skins/xkiosk/components/_base/modal-link/africa/modal-link.vue